// Copyright © 2019-2026 Focal Systems. All rights reserved.

import type * as React from "react";

/**
 * Realm (fingerprint) icon with a "+" badge in the bottom-right corner.
 * Fully Lucide-compatible (accepts all SVG props, inherits currentColor).
 */
export function RealmPlusIcon(props: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M12 10a2 2 0 0 0-2 2c0 1.02-.1 2.51-.26 4" />
      <path d="M13.15 21.5 L13 22" />
      <path d="M14 13.12v2.38" />
      <path d="M19 16v6" />
      <path d="M2 12a10 10 0 0 1 18-6" />
      <path d="M2 16h.01" />
      <path d="M22 13.5c0-1-.069-2.854-.2-3.5" />
      <path d="M22 19h-6" />
      <path d="M5 19.5C5.5 18 6 15 6 12a6 6 0 0 1 .34-2" />
      <path d="M8.65 22c.21-.66.45-1.32.57-2" />
      <path d="M9 6.8a6 6 0 0 1 9 5.2" />
    </svg>
  );
}
